export enum EnterpriseEnums {
    //Logos de la Empresa - Se usa para validaciones
    logo = 1,
    logoFooter = 2,
    signature = 3
}